export const DISCOUNT_TYPE = 'Descuento por uso de saldo';
export const PAYMENT_TYPE = 'Tipo de pago no especificado';

export const bankAccounts = [
    { bank: "BANREGIO", account: "058200000000710129" },
    { bank: "BANAMEX", account: "002320034546376654" },
    { bank: "BBVA", account: "01230004721764755" },
];
